<div class="job-code-list">
  <div
    class="coin-stepper-container"
    [class.german-partial-evaluation]="isQuestionnaireDisabledForGermanWithPartialEvaluation()">
    <mat-horizontal-stepper
      #stepper
      [selectedIndex]="isQuestionnaireDisabledForGermanWithPartialEvaluation() ? 3 : 4">
      <mat-step
        [label]="'mercer-support.dialog.family' | translate"
        [completed]="
          [mercerJobTypeEnum.Family] | pure: areStepsCompleted : jobProfilesTop : currentMercerData
        "></mat-step>
      <mat-step
        [label]="'mercer-support.dialog.sub-family' | translate"
        [completed]="
          [mercerJobTypeEnum.SubFamily] | pure: areStepsCompleted : jobProfilesTop : currentMercerData
        "></mat-step>
      <mat-step
        [label]="'mercer-support.dialog.specialization' | translate"
        [completed]="
          [mercerJobTypeEnum.Specialization] | pure: areStepsCompleted : jobProfilesTop : currentMercerData
        "></mat-step>
      @if (!isQuestionnaireDisabledForGermanWithPartialEvaluation()) {
        <mat-step
          [label]="'mercer-support.dialog.career-stream-level-pc' | translate"
          [completed]="
            [mercerJobTypeEnum.CareerStream, mercerJobTypeEnum.CareerLevel]
              | pure: areStepsCompleted : jobProfilesBottom : currentMercerData
          "></mat-step>
      }
      <!-- fake selection -->
      <mat-step></mat-step>
    </mat-horizontal-stepper>
  </div>
  <div class="sections">
    @if (!memberDetails()?.newJobCode && currentMercerData && isValidationEditable) {
      <div
        animate.enter="fade-in"
        animate.leave="fade-out"
        class="new-job-code-selection mat-elevation-z4">
        <h4>{{ 'mercer-support.dialog.already-know-job-code-info' | translate }}</h4>
        <div class="job-code-actions">
          <coin-v2-dropdown
            #jobCodeSearch="dropdownSearch"
            matFormFieldClass="customer-grey"
            required
            [disabled]="isLocked()"
            [label]="'mercer-support.dialog.mercer-job-code' | translate"
            [dataSource]="jobCodeLazyLoadFn"
            [(ngModel)]="selectedJobCode">
            @for (jobCode of jobCodeSearch.results() | sortAlphabetically; track jobCode) {
              <ng-template [coinValue]="jobCode">{{ jobCode }}</ng-template>
            }
          </coin-v2-dropdown>
          <coin-v2-button
            [type]="'secondary'"
            [icon]="'check'"
            [disabled]="!selectedJobCode || selectedJobCode === currentMercerData.jobCode || isLocked()"
            [text]="'general.btnSave' | translate"
            (click)="saveNewJobCode()"></coin-v2-button>
        </div>
      </div>
    }
    <div class="items">
      @for (profile of jobProfilesTop; track trackByJobProfileItem($index, profile); let last = $last) {
        <customer-position-job-code-card
          [isLocked]="isLocked()"
          [memberDetails]="memberDetails()"
          [mercerData]="currentMercerData"
          [profile]="profile"
          [dialogType]="dialogType()"
          [hideNextButton]="isQuestionnaireDisabledForGermanWithPartialEvaluation() && last"
          [mercerDataChanged$]="mercerDataChanged$"
          [fetchingData$]="fetchingData$"
          [isEditable]="arePositionSpecsEditable"
          [isQuestionnaireDisabledForGermanWithPartialEvaluation]="
            isQuestionnaireDisabledForGermanWithPartialEvaluation()
          "
          (next)="goToNextProfile(profile)"
          (openedEditMode)="processProfileEditModeChange(profile)"
          (setupNewMercerData)="setupJobProfiles()"></customer-position-job-code-card>
      }
    </div>
    @if (isSurveyResultVisible) {
      <div class="survey-info">
        <p class="bold">{{ 'mercer-support.dialog.career-stream-level-pc-survey-info' | translate }}</p>
        @if (!mercerSupportDetailsService.isReadOnly && !isLocked()) {
          <coin-v2-button
            type="primary"
            iconPos="left"
            icon="support"
            [disabled]="!isSurveyEditable"
            [text]="'mercer-support.dialog.start-survey' | translate"
            (click)="setSurveyTab.emit()"></coin-v2-button>
        }
      </div>
    } @else {
      <p class="career-info-not-applicable bold">
        <mat-icon>info</mat-icon>
        {{ 'mercer-support.dialog.career-info-not-applicable' | translate }}
      </p>
    }
    @if (isSurveyResultVisible) {
      <div class="items">
        @for (profile of jobProfilesBottom; track trackByJobProfileItem($index, profile)) {
          <customer-position-job-code-card
            [isLocked]="isLocked()"
            [mercerData]="currentMercerData"
            [profile]="profile"
            [memberDetails]="memberDetails()"
            [dialogType]="dialogType()"
            [mercerDataChanged$]="mercerDataChanged$"
            [fetchingData$]="fetchingData$"
            [isEditable]="arePositionSpecsEditable"
            [isQuestionnaireDisabledForGermanWithPartialEvaluation]="
              isQuestionnaireDisabledForGermanWithPartialEvaluation()
            "
            (next)="goToNextProfile(profile)"
            (openedEditMode)="processProfileEditModeChange(profile)"
            (setupNewMercerData)="setupJobProfiles()"
            (saveJobCode)="saveNewJobCode()"></customer-position-job-code-card>
        }
      </div>
    }
    @if (isSurveyResultVisible) {
      <div class="items">
        @if (!isPositionClassHidden()) {
          <customer-position-survey-result
            [isLocked]="isLocked()"
            [memberDetails]="memberDetails()"
            [derivedPositionClass]="derivedPositionClass()"
            [positionClassValidationErrors]="positionClassValidationErrors()"
            [positionClassValidationWarnings]="positionClassValidationWarnings()"
            [isEditable]="arePositionSpecsEditable && !disablePositionClass()"
            [dialogType]="dialogType()"
            [isFinalizationAllowed]="isFinalizationAllowed()"
            [hideSaveButton]="hideSavePcButton()"
            (finalizePositionClass)="finalizePositionClass.emit()"
            (changePositionClass)="changePositionClass.emit($event)"
            (acceptProposedPositionClass)="acceptProposedPositionClass.emit()"></customer-position-survey-result>
        }
      </div>
    }
  </div>
</div>
